export type ReportStatus = 'pending' | 'acknowledged' | 'in_progress' | 'closed';

export interface ReportFile {
  filename: string;
  url: string;
}

export interface WhistleblowReport {
  id: number;
  referenceCode: string;
  infractionType: string;
  summary: string;
  factsWhen: string | null;
  factsWho: string | null;
  factsEvidence: string | null;
  email: string | null;
  status: ReportStatus;
  submittedAt: string;
  acknowledgedAt: string | null;
  acknowledgedBy: string | null;
  closedAt: string | null;
  closedBy: string | null;
  purgeAfter: string;
  files: ReportFile[];
}

export const INFRACTION_LABELS: Record<string, string> = {
  corruption: 'Corrupção',
  procurement: 'Contratação pública',
  conflict_of_interest: 'Conflito de interesses',
  financial_management: 'Gestão financeira',
  data_protection: 'Proteção de dados',
  environment_safety: 'Ambiente / segurança',
  other: 'Outro',
};

export const STATUS_LABELS: Record<ReportStatus, string> = {
  pending: 'Pendente',
  acknowledged: 'Receção acusada',
  in_progress: 'Em análise',
  closed: 'Concluída',
};

// Token-based, light. Four distinct treatments: gold (awaiting) · purple
// (receipt sent) · neutral (under analysis) · green (closed).
export const STATUS_COLORS: Record<ReportStatus, string> = {
  pending: 'bg-secondary/10 text-secondary-dark border-secondary/30',
  acknowledged: 'bg-primary/10 text-primary border-primary/30',
  in_progress: 'bg-background text-on-surface border-line-strong',
  closed: 'bg-tertiary/10 text-tertiary border-tertiary/30',
};

export function formatReportDate(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('pt-PT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

// Highlights pending reports older than 7 days — the legal deadline for the
// acusação de receção (Art. 11 Lei 93/2021).
export function isOverdueAcknowledgement(report: WhistleblowReport): boolean {
  if (report.status !== 'pending') return false;
  const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
  return Date.now() - new Date(report.submittedAt).getTime() > sevenDaysMs;
}
